import httpClient from "../axios/interceptors";
import { AuthProfileResponse, ChangePasswordInput, ChangePasswordResponse, CreateUserSystemInput, CreateUserSystemResponse, DeleteUserSystemInput, DeleteUserSystemResponse, InputUpdateFactory, InputUpdateUserProfile, KeepAliveInput, LoginPasswordInput, LoginPasswordResponse, RequestOPTAuthInput, ResponseKeepAlive, ResponseRequestAuthOTP, ResponseSubmitAuthOTP, SubmitOTPAuthInput, UpdateFactoryResponse, UpdateUserProfileResponse, UpdateUserSystemInput, UserRoleWithoutAdminResponse, UserSystemInput, UserSystemResponse } from './interface';
import { AxiosResponse } from 'axios'
import { API } from './endpoint';



const handleResponseError = (error: { response: { data: { error: any } } }) => {
  if (error?.response?.data?.error) {
    throw error.response.data.error
  }
  throw error
}



export const requestAuthLogin = async (
  input: SubmitOTPAuthInput
): Promise<ResponseSubmitAuthOTP> => {
  const data: AxiosResponse<ResponseSubmitAuthOTP> = await httpClient
    .post(API.submitAuthOtp, input)
    .catch((error) => handleResponseError(error))
  return data.data
}


export const requestAuthRequestOtp = async (
  input: RequestOPTAuthInput
): Promise<ResponseRequestAuthOTP> => {
  const data: AxiosResponse<ResponseRequestAuthOTP> = await httpClient
    .post(API.requestAuthOtp, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const requestAuthLoginPassword = async (
  input: LoginPasswordInput
): Promise<LoginPasswordResponse> => {
  const data: AxiosResponse<LoginPasswordResponse> = await httpClient
    .post(API.authLoginPassword, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const changePassword = async (
  input: ChangePasswordInput
): Promise<ChangePasswordResponse> => {
  const data: AxiosResponse<ChangePasswordResponse> = await httpClient
    .post(API.changePassword, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getAuthProfile = async (): Promise<AuthProfileResponse> => {
  const data: AxiosResponse<AuthProfileResponse> = await httpClient
    .get(API.authProfile)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const requestKeepAlive = async (
  input: KeepAliveInput
): Promise<ResponseKeepAlive> => {
  const data: AxiosResponse<ResponseKeepAlive> = await httpClient
    .post(API.keepAlive, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const updateFactory = async (
  input: InputUpdateFactory
): Promise<UpdateFactoryResponse> => {
  const data: AxiosResponse<UpdateFactoryResponse> = await httpClient
    .post(API.updateFactory, input)
    .catch((error) => handleResponseError(error))
  return data.data
}



export const updateUserProfile = async (
  input: InputUpdateUserProfile
): Promise<UpdateUserProfileResponse> => {
  const data: AxiosResponse<UpdateUserProfileResponse> = await httpClient
    .post(API.updateUserProfile, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getUserRoleWithoutAdmin = async (): Promise<UserRoleWithoutAdminResponse> => {
  const data: AxiosResponse<UserRoleWithoutAdminResponse> = await httpClient
    .get(API.getUserRoleWithoutAdmin)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getUserSystem = async (
  input: UserSystemInput
): Promise<UserSystemResponse> => {
  const data: AxiosResponse<UserSystemResponse> = await httpClient
    .post(API.getUserSystem, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const createUserSystem = async (
  input: CreateUserSystemInput
): Promise<CreateUserSystemResponse> => {
  const data: AxiosResponse<CreateUserSystemResponse> = await httpClient
    .post(API.createUserSystem, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const deleteUserSystem = async (
  input: DeleteUserSystemInput
): Promise<DeleteUserSystemResponse> => {
  const data: AxiosResponse<DeleteUserSystemResponse> = await httpClient
    .post(API.deleteUserSystem , input)
    .catch((error) => handleResponseError(error))
  return data.data
}


export const updateUserSystem = async (
  input: UpdateUserSystemInput
): Promise<CreateUserSystemResponse> => {
  const data: AxiosResponse<CreateUserSystemResponse> = await httpClient
    .post(API.updateUserSystem, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

